import { useTranslation } from 'react-i18next'

import { cn } from '@/utils/style'

// Node status mapping
// Based on common status codes: 1 = Online, 2 = Standby, 0 or 3 = Offline
export enum NodeStatus {
  Offline = 0,
  Online = 1,
  Standby = 2,
}

interface StatusBadgeProps {
  status: number
  className?: string
}

const statusConfig: Record<
  number,
  {
    labelKey: string
    dotClass: string
    textClass: string
  }
> = {
  [NodeStatus.Online]: {
    labelKey: 'common.online',
    dotClass: 'bg-green-500',
    textClass: 'text-primary',
  },
  [NodeStatus.Standby]: {
    labelKey: 'common.standby',
    dotClass: 'bg-neutral-400',
    textClass: 'text-primary',
  },
  [NodeStatus.Offline]: {
    labelKey: 'common.offline',
    dotClass: 'bg-red-500',
    textClass: 'text-primary',
  },
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const { t } = useTranslation('privateRegion')
  const config = statusConfig[status] ?? statusConfig[NodeStatus.Offline]

  return (
    <div
      className={cn(
        'flex items-center space-x-2 px-3 py-1 rounded-full border border-neutral-100',
        className,
      )}
    >
      <div className={cn('w-2 h-2 rounded-full', config.dotClass)} />
      <div className={cn('t-sb', config.textClass)}>{t(config.labelKey)}</div>
    </div>
  )
}
